
import Vue from "vue"
import Component from "vue-class-component"
import {QItem, QItemSection, QSelect} from "quasar"
import {Inject} from "vue-property-decorator"
import {Plan, PlanService} from "@/superannuation/PlanService"
import Axios from "axios"

@Component({components: {QSelect, QItem, QItemSection}})
export default class SelectPlanDropDown extends Vue {
  @Inject()
  planService: PlanService

  options = []
  model: string | null = <any>null

  $refs: {
    select: QSelect
  }

  created() {
    // check session storage
    if (
      this.planService.current == null &&
      sessionStorage.getItem("currentPlan") !== null
    ) {
      this.planService.current = JSON.parse(
        <string>sessionStorage.getItem("currentPlan")
      )
      this.$emit("plan-chosen")
    }
  }

  checkInput(input: string) {
    if (input === "") {
      this.options = []
    } else {
      void this.findPlans(input)
    }
  }

  async findPlans(input: string) {
    const response = await Axios.get("/api/plan", {
      params: {name: input},
    })
    this.options = response.data
    this.$refs.select.refresh()
    this.$refs.select.showPopup()
  }

  async setPlan(option: Plan) {
    setTimeout(async () => {
      await Axios.get(`/api/plan/${option.id}`)
        .then(response => {
          this.planService.current = response.data
          this.planService.savePlanToSessionStorage(response.data)
          this.$emit("plan-chosen")
        })
        .catch(error => {
          console.log(error.message)
        })
    }, 200)
  }
}
